import { ageLore, ageName } from '@data/lore';
import { ageVisual, visualAge } from '@data/visual-ages';
import { getLang, t } from '@i18n/i18n';
import './age-title.css';

/** Presentation clock is supplied by the world, so skip and rebuild cancel it. */
export class AgeTitle {
  private root = document.createElement('aside');
  private name = document.createElement('strong');
  private era = document.createElement('span');
  private lore = document.createElement('p');
  private age = -1;
  private lang = '';

  constructor() {
    this.root.className = 'age-arrival';
    this.root.setAttribute('role', 'status');
    this.root.append(this.name, this.era, this.lore);
    document.body.append(this.root);
    this.hide();
  }

  show(age: number, elapsed: number): void {
    if (age !== this.age || getLang() !== this.lang) {
      this.age = age; this.lang = getLang();
      this.name.textContent = ageName(age);
      this.era.textContent = t('dawn.era' + ageVisual(age).era);
      this.lore.textContent = this.lang === 'tr' || this.lang === 'en'
        ? ageLore(age).split(';')[0].replace(/[.!]$/, '') + '.'
        : t('dawn.lore' + visualAge(age));
    }
    this.root.hidden = elapsed < 1.2 || elapsed >= 3.5;
    this.root.style.opacity = String(Math.max(0, Math.min(1, (elapsed - 1.2) / .3, (3.5 - elapsed) / .6)));
  }

  hide(): void { this.root.hidden = true; }
}
